<app-studies-list *ngIf="hasStudies; else noData" parent="site" [customerId]="customerId" [siteId]="siteId" [currentSite]="currentSite"></app-studies-list>

<ng-template #noData>
	<div class="mt-4 alert alert-info">{{'g.no_data_to_show' | translate}}</div>
</ng-template>